module.exports = __webpack_public_path__ + "static/img/tup5.6722399.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/common/tup5.png
// module id = Cd9V
// module chunks = 0